import { SignUp } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';
import { ROUTE_NAMES } from '@tsgecart/config';
import { clerkAppearance } from '../lib/auth/clerk-appearance.js';
import { resolveSafeReturnPath } from '../lib/auth/safe-redirect.js';

export function SignUpPage() {
  const [searchParams] = useSearchParams();
  const returnTo = resolveSafeReturnPath(searchParams.get('redirect'), ROUTE_NAMES.home);

  return (
    <main className="flex min-h-screen items-center justify-center bg-neutral-50 p-4">
      <SignUp
        routing="path"
        path={ROUTE_NAMES.signUp}
        signInUrl={ROUTE_NAMES.signIn}
        fallbackRedirectUrl={returnTo}
        appearance={clerkAppearance}
      />
    </main>
  );
}
